<template>

  <div class="download__layout">
    <div class="download-container">
      <div class="download-box">
        <div class="download-tab">
          <div @click="activeIndex='0'" ref="targetApp">
            <p>APP下载</p>
            <span v-if="activeIndex === '0'"></span>
          </div>
          <div @click="activeIndex='1'" ref="targetMt">
            <p>MT4/5下载</p>
            <span v-if="activeIndex === '1'"></span>
          </div>
        </div>
        <div v-show="activeIndex === '0'">
          <div class="download-title">
            <p>即刻下载 掌控您的财富先机</p>
            <p>智赢未来，开启财富增长新篇章，指尖轻触，商机尽在掌握</p>
            <p>智赢未来，开启财富增长新篇章</p>
            <p>指尖轻触，商机尽在掌握</p>
          </div>
          <div class="download-introduce">
            <div>
              <img src="@/assets/imgs/home/desktop-icon.png" alt="">
              <span>顶尖技术团队倾力打造</span>
            </div>
            <div>
              <img src="@/assets/imgs/home/update-icon.png" alt="">
              <span>2000+日夜精心打磨APP细节</span>
            </div>
            <br />
            <div>
              <img src="@/assets/imgs/home/user-icon.png" alt="">
              <span>200+万用户使用</span>
            </div>
            <div>
              <img src="@/assets/imgs/home/earth-icon.png" alt="">
              <span>权威平台认可</span>
            </div>
          </div>
          <div class="downloads">
            <div class="download-introduces">
              <div>
                <img src="@/assets/imgs/home/desktop-icon.png" alt="">
                <span>顶尖团队倾力打造</span>
              </div>
              <div>
                <img src="@/assets/imgs/home/update-icon.png" alt="">
                <span>千日精心打磨细节</span>
              </div>
              <br />
              <div>
                <img src="@/assets/imgs/home/user-icon.png" alt="">
                <span>200+万用户使用</span>
              </div>
              <div>
                <img src="@/assets/imgs/home/earth-icon.png" alt="">
                <span>权威平台广泛认可</span>
              </div>
            </div>
          </div>
          <div class="download-code">
            <!-- <div class="download-code-cell">
              <div class="download-code-cell-title">MT4账户专用版本</div>
           
              <div class="download-code-cell-box">
                <div class="code-item" @mouseenter="downLoadIos('0')" @mouseleave="leaveIos('0')">
                  <img class="imgs" src="@/assets/imgs/home/iOS.png" alt="" v-show="showIos">
                  <Qrcode :link="iosMt4DownloadUrl" :size="150" :iconSize="30" v-show="showIoss" />
                </div>
                <div class="code-item" @mouseenter="downLoadAndroid('0')" @mouseleave="leaveAndroid('0')">
                  <img class="imgs" src="@/assets/imgs/home/Android.png" alt="" v-show="showAndroid">
                  <Qrcode :link="androidMt4DownloadUrl" :size="150" v-show="showAndroids" />
                </div>
              </div>
            </div> -->
            <div class="download-code-cell">
              <!-- <div class="download-code-cell-title">MT5账户专用版本</div> -->
             
              <div class="download-code-cell-box">
                <div class="code-item" @mouseenter="downLoadIos('1')" @mouseleave="leaveIos('1')">
                  <img class="imgs" src="@/assets/imgs/home/iOS.png" alt="" v-show="showIos1">
                  <Qrcode :link="iosMt5DownloadUrl" :size="150" :iconSize="30" v-show="showIoss1" />
                  <!-- <div class="code-item-btn">iOS</div> -->
                </div>
                <div class="code-item" @mouseenter="downLoadAndroid('1')" @mouseleave="leaveAndroid('1')">
                  <img class="imgs" src="@/assets/imgs/home/Android.png" alt="" v-show="showAndroid1">
                  <Qrcode :link="androidDownloadUrl" :size="150" v-show="showAndroids1" />
                  <!-- <div class="code-item-btn">Android</div> -->
                </div>
              </div>
            </div>
            <!-- <div class="download-code-cells">
              <div class="download-code-cell-title">MT4账户专用版本</div>
              <div class="download-code-cell-box">
                <div class="code-item">
                  <div class="code-item-btn" style="width: 104px;" @click="iosDownoad">iOS</div>
                </div>
                <div class="code-item">
                  <div class="code-item-btn" style="width: 104px;" @click="androidDownload">Android</div>
                </div>
              </div>
            </div> -->
            <div class="download-code-cells">
              <!-- <div class="download-code-cell-title">MT5账户专用版本</div> -->
              <div class="download-code-cell-box">
                <div class="code-item">
                  <!-- <Qrcode :link="iosMt5DownloadUrl" :size="104" :iconSize="30" /> -->
                  <div class="code-item-btn" style="width: 104px;" @click="iosDownoad1">iOS</div>
                </div>
                <div class="code-item">
                  <!-- <Qrcode :link="androidDownloadUrl" :size="104" /> -->
                  <div class="code-item-btn" style="width: 104px;" @click="androidDownload1">Android</div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="download-tips">
            温馨提示： <br />
            1.MT4版本，仅MT4账户可用；MT5版本，仅MT5账户可用，两者不互通。 <br />
            2.如无法确定所用账户的MT版本，可联系在线客服查询。
          </div> -->
          <div class="download-mt5">
            <img src="@/assets/imgs/home/wap/MT5.png" alt="">
          </div>
        </div>
        <div v-show="activeIndex === '1'">
          <div class="download-title">
            <p>下载MT4/5 即刻在线交易</p>
            <p>集行情图表、技术分析、交易操作三大功能于一身</p>
          </div>
          <div class="download-introduce-two">
            MT4集行情图表、技术分析和交易操作于一体，支持多种交易功能，如下单、限价单、止损止盈等，是全球广泛使用的行情软件，超过300家经纪商和银行选用，备受青睐。 <br />
            MT5是一款专业金融交易软件，支持多品种交易，配备先进图表分析、技术指标和自动化交易，适合专业交易者和经验丰富投资者。
          </div>
          <div class="download-code">
            <div class="download-code-cell">
              <div class="download-code-cell-title">MT4</div>
            
              <div class="download-code-cell-box">
                <div class="code-item" @mouseenter="downLoadIos('2')" @mouseleave="leaveIos('2')">
                  <img class="imgs1" src="@/assets/imgs/home/iOS.png" alt="" v-show="showIos2">
                 
                  <Qrcode :link="newiosMt4" :size="150" :iconSize="30" v-show="showIoss2" />
                  
                </div>
                <div class="code-item" @mouseenter="downLoadAndroid('2')" @mouseleave="leaveAndroid('2')">
                  <img class="imgs1" src="@/assets/imgs/home/Android.png" alt="" v-show="showAndroid2">
                  <Qrcode :link="newAndroidMt4" :size="150" v-show="showAndroids2" />
                  
                </div>
                <div class="code-item hover" @click="windowsDownload('MT4')">
                  <div class="code-item-img">
                    <img src="@/assets/imgs/home/windows.png" alt="">
                  </div>
                  <div class="code-item-btn">Windows</div>
                </div>
              </div>
            </div>
            <div class="download-code-cell">
              <div class="download-code-cell-title">MT5</div>
          
              <div class="download-code-cell-box">
                <div class="code-item" @mouseenter="downLoadIos('3')" @mouseleave="leaveIos('3')">
                  <img class="imgs1" src="@/assets/imgs/home/iOS.png" alt="" v-show="showIos3">
                  <Qrcode :link="newiosMt5" :size="150" :iconSize="30" v-show="showIoss3" />
                  
                </div>
                <div class="code-item" @mouseenter="downLoadAndroid('3')" @mouseleave="leaveAndroid('3')">
                  <img class="imgs1" src="@/assets/imgs/home/Android.png" alt="" v-show="showAndroid3">
                  <Qrcode :link="newAndroidMt5" :size="150" v-show="showAndroids3" />
                  
                </div>
                <div class="code-item hover" @click="windowsDownload('MT5')">
                  <div class="code-item-img">
                    <img src="@/assets/imgs/home/windows.png" alt="">
                  </div>
                  <div class="code-item-btn">Windows</div>
                </div>
              </div>
            </div>
            <div class="download-code-cells">
              <div class="download-code-cell-title">MT4</div>
              <div class="download-code-cell-box">
                <div class="code-item">

                  <div class="code-item-btn" @click="Appstoreload('MT4')" style="width: 104px;">iOS</div>
                </div>
                <div class="code-item">

                  <div class="code-item-btn" style="width: 104px;" @click="Androidload('MT4')">Android</div>
                </div>

              </div>
            </div>
            <div class="download-code-cells">
              <div class="download-code-cell-title">MT5</div>
              <div class="download-code-cell-box">
                <div class="code-item">

                  <div class="code-item-btn" @click="Appstoreload('MT5')" style="width: 104px;">iOS</div>
                </div>
                <div class="code-item">

                  <div class="code-item-btn" style="width: 104px;" @click="Androidload('MT5')">Android</div>
                </div>

              </div>
            </div>
          </div>
          <div class="download-mt4">
            <img src="@/assets/imgs/home/wap/MT4.png" alt="">
          </div>
        </div>
        <img v-show="activeIndex === '1'&&screenWidth>500" class="download-computer-img"
          src="@/assets/imgs/home/computer.png" alt="">

      </div>
      <img v-show="activeIndex === '0' && screenWidth > 500" class="download-mobile-img"
        src="@/assets/imgs/home/mobile.png" alt="">
    </div>
  </div>




</template>

<script>
import { mapState  } from "vuex";
import Qrcode from '@/component/qr-code/index.vue'

export default {
  components: { Qrcode },
  props:{
   controls:{
    type:Number
   }
  },
  data() {
    return {
      activeIndex: '0',
      screenWidth: document.body.clientWidth,//实时屏幕宽度
      showAndroid:true,
      showAndroids:false,
      showIos:true,
      showIoss:false,
      showAndroid1: true,
      showAndroids1: false,
      showIos1: true,
      showIoss1: false,
      showAndroid2: true,
      showAndroids2: false,
      showIos2: true,
      showIoss2: false,
      showAndroid3: true,
      showAndroids3: false,
      showIos3: true,
      showIoss3: false

    };
  },
  computed: {
    ...mapState('common', {
      androidMt4DownloadUrl: 'androidMt4DownloadUrl',
      androidDownloadUrl: 'androidDownloadUrl',
      iosMt4DownloadUrl: 'iosMt4DownloadUrl',
      iosMt5DownloadUrl: 'iosMt5DownloadUrl',
      newiosMt4: 'newiosMt4',
      newiosMt5: 'newiosMt5',
      newAndroidMt4:'newAndroidMt4',
      newAndroidMt5:'newAndroidMt5'
    })
  },
  created() {
    if (window.location.origin.indexOf("xsintlg") !== -1) {
      this.control = false;
    }
  },
  methods: {
    downLoadIos(type){

      if(type==0){
        this.showIos = false
        this.showIoss = true
      }
      if (type == 1) {
        this.showIos1 = false
        this.showIoss1 = true
      }
      if (type == 2) {
        this.showIos2 = false
        this.showIoss2 = true
      }
      if (type == 3) {
        this.showIos3 = false
        this.showIoss3 = true
      }
      
    },
    leaveIos(type) {

      if (type == 0) {
        this.showIos = true
        this.showIoss = false
      } 
      if (type == 1) {
        this.showIos1 = true
        this.showIoss1 = false
      } 
      if (type == 2) {
        this.showIos2 = true
        this.showIoss2 = false
      } 
      if (type == 3) {
        this.showIos3 = true
        this.showIoss3 = false
      } 
      
      

    },
    leaveAndroid(type){
      if(type==0){
        this.showAndroid = true
        this.showAndroids = false 
      }
      if (type == 1) {
        this.showAndroid1 = true
        this.showAndroids1 = false
      }
      if (type == 2) {
        this.showAndroid2 = true
        this.showAndroids2 = false
      }
      if (type == 3) {
        this.showAndroid3 = true
        this.showAndroids3 = false
      }
      
    },
    downLoadAndroid(type) {
     
      if (type == 0) {
        this.showAndroid = false
        this.showAndroids = true
      } 
      if (type == 1) {
        this.showAndroid1 = false
        this.showAndroids1 = true
      } 
      if (type == 2) {
        this.showAndroid2 = false
        this.showAndroids2 = true
      } 
      if (type == 3) {
        this.showAndroid3 = false
        this.showAndroids3 = true
      } 

    },
   
    // mt4ios下载
    iosDownoad(){
      window.open(this.iosMt4DownloadUrl)
    },
    // mt4安卓
    androidDownload(){
      window.open(this.androidMt4DownloadUrl)

    },
    // mt5ios下载
    iosDownoad1() {
      window.open(this.iosMt5DownloadUrl)

    },
    // mt5安卓
    androidDownload1() {
      window.open(this.androidDownloadUrl)

    },
    // 点击跳转到指定位置
    scrollToTarget() {
      this.$emit('scrollTop',this.activeIndex)
      
    },
    windowsDownload(type){
      const userAgent = navigator.userAgent;
   
      let deviceType = '';
      if (/android/i.test(userAgent)) {
        // 判断为安卓设备
        deviceType = 'Android';
        this.$message(`当前设备为: ${deviceType},请下载对应App`);
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // 判断为苹果iOS设备，同时排除Windows Phone等可能包含'iPad'、'iPhone'、'iPod'字样的设备
        deviceType = 'iOS';
        this.$message(`当前设备为: ${deviceType},请下载对应App`);
      } else {
        // 其他设备，如桌面设备等
        deviceType = 'Other';
        if(type === 'MT5') {
          window.open('https://download.terminal.free/cdn/web/red.lion.bullion/mt5/redlionbullionmt5setup.exe');
        } else {
          window.open('https://download.terminal.free/cdn/web/red.lion.bullion/mt4/redlionbullion4setup.exe');
        }
      } 
    },
    //ios设备下载
    Appstoreload(type) {
      const userAgent = navigator.userAgent;

      let deviceType = '';
      const downloadUrl = type === 'MT4' ? this.newiosMt4 : this.newiosMt5;
      if (/android/i.test(userAgent)) {
        // 判断为安卓设备
        deviceType = 'Android';
        this.$message(`当前设备为: ${deviceType},请下载对应App`);
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // 判断为苹果iOS设备，同时排除Windows Phone等可能包含'iPad'、'iPhone'、'iPod'字样的设备
        deviceType = 'iOS';
        window.open(downloadUrl);
      } else {
        // 其他设备，如桌面设备等
        deviceType = 'Other';
        window.open(downloadUrl);
      }
    },
    //安卓设备下载
    Androidload(type) {
      const userAgent = navigator.userAgent;
    
      let deviceType = '';
      let downloadUrl = type === 'MT4' ? this.newAndroidMt4 : this.newAndroidMt5;
      const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
      if (isAndroid && window.android) {
        window.android.onOpenUrl(downloadUrl);
      } else if (/android/i.test(userAgent)) {
        // 判断为安卓设备
        deviceType = 'Android';
        window.open(downloadUrl);
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // 判断为苹果iOS设备，同时排除Windows Phone等可能包含'iPad'、'iPhone'、'iPod'字样的设备
        deviceType = 'iOS';
        this.$message(`当前设备为: ${deviceType},请下载对应App`);
      } else {
        // 其他设备，如桌面设备等
        deviceType = 'Other';
        window.open(downloadUrl);
      }
    },

  },
  watch: {
    $route(nv) {

      if(nv.query.key==1){
        this.activeIndex='0'
        this.scrollToTarget()
      }else{
        this.activeIndex='1'
        this.scrollToTarget()
      }
    }
  },
};
</script>

<style lang="less" scoped>
.download__layout {
 
  position: relative;
  color: #FFFFFF;
  padding-top: 100px;

  .hover {
    cursor: pointer;
  }

  .download-container {
    background: url('../../assets/imgs/home/download-bg.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 50px 0;
    height: 746px;

    .download-box {
      width: 1240px;
      margin: auto;
      position: relative;
      z-index: 2;

      .download-tab {
        display: flex;
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 40px;

        >div {
          margin-right: 62px;
          cursor: pointer;
          position: relative;

          span {
            width: 40px;
            height: 4px;
            background: #FA2314;
            position: absolute;
            bottom: -12px;
            left: 0;
            right: 0;
            margin: auto;
          }
        }
      }

      .download-title {
        margin-bottom: 28px;
        p {
          &:first-child {
            font-size: 46px;
            margin-bottom: 12px;

          }
          &:nth-child(3),&:nth-child(4){
            display: none;
          }
        }
      }

      .download-introduce {
        display: block;
        flex-wrap: wrap;
        >div {
          display: inline-block;
          width: 250px;
          margin-bottom: 18px;

          img {
            position: relative;
            top: 6px;
            margin-right: 18px;
          }
        }
      }
      .downloads{
        display: none;
        
      }
       .download-introduces {
        display: flex;
            flex-wrap: wrap;
            align-items: center;
            text-align: center;
        >div {
          display: inline-block;
          width: 50%;
          margin-bottom: 18px;

          img {
            position: relative;
            top: 6px;
            margin-right: 10px;
              width: 24px;
             height: 24px;
          }
            span{
            font-size: 14px;
          }
        }
      }

      .download-introduce-two {
        width: 550px;
        line-height: 26px;
      }

    }
    .download-mobile-img {
      position: absolute;
      width: 786px;
      right: 50px;
      bottom: 0;
    }

    .download-computer-img {
      position: absolute;
      width: 618px;
      right: 0;
      bottom: 30px;
    }

    .download-code {
      display: flex;
      text-align: center;
      margin-top: 32px;
      position: relative;
      z-index: 2;

      &-cell {
        margin-right: 34px;
        display: block;

        &-title {
          font-weight: 700;
          margin-bottom: 20px;
          font-size: 18px;
        }

        &-box {
          display: flex;
          justify-content: center;
          margin-bottom: 25px;

          .code-item {
            margin-right: 12px;
            .imgs{
              width: 150px;
              height: 150px;
            }
            .imgs1{
              width: 150px;
              height: 150px;
            }
            &:last-child {
              margin-right: 0;

             
            }
            &-img {
              width: 104px;
              height: 104px;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: 10px;

              img {
                width: 88px;
                height: 88px;
              }
            }
            &-btn {
              line-height: 32px;
              background: #FA2314;
              color: #fff;
              margin-top: 6px;
              font-weight: 700;
            }
          }
        }
      }
      &-cells{
        display: none;
      }    
    }

    .download-tips {
      color: #93939F;
      font-size: 12px;
    }
    .download-mt5{
      display: none;
    }
     .download-mt4{
      display: none;
    }
  }
}

  @media screen and (max-width: 500px) {
    .download__layout{
     .download-container{
      background: url('../../assets/imgs/home/wap/bg1.png') no-repeat;
      background-size: 100% 100%;
      height: 100%;
      .download-box {
        width: 100%;
        height: auto;
         .download-tab {
          display: flex;
          align-items: center;
          justify-content: space-around;
          font-size: 22px;
          >div {
          margin-right: 0px;
        }
         }
         .download-title {
              text-align: center;

            p {
             &:first-child {
              font-size: 24px;
             }
             &:nth-child(2){
              display: none;
             }
               &:nth-child(3),&:nth-child(4){
            display: block;
              font-size: 14px;

          }
        }
          }
          .download-introduce{
            display: none;
          }
          .downloads{
            display: block;
          }
            .download-introduce-two {
        width: 100%;
        padding: 0 20px;
        line-height: 24px;
        box-sizing: border-box;
        font-size: 14px;
      }
          .download-code {
            display: flex;
            flex-direction: column;
          }
          .download-mt5{
              display: block;
             img{
               width: 80%;
               margin-left: 20%;
               margin-top: 10%;
               overflow: hidden;
              height: auto;
             }
          }
           .download-mt4{
              display: block;
               img{
               width: 88%;
              height: auto;
             }
            }
      }
      .download-tips {
        color: #fff;
        text-align: left;
        padding: 0 20px;
      }
       .download-code {
      display: flex;
      text-align: center;
      margin-top: 32px;
      position: relative;
      z-index: 2;

      &-cell {
        display: none;

       
      }
            &-cells {
              margin-right: 34px;
              display: block;
              margin-right: 0;
      
              &-title {
                font-weight: 700;
                margin-bottom: 20px;
                font-size: 18px;
              }
      
              &-box {
                display: flex;
                justify-content: center;
                margin-bottom: 25px;
      
                .code-item {
                  margin-right: 12px;
                    width: 104px;
                  &:last-child {
                    margin-right: 0;
      
                    img {
                      width: 62px;
                      height: 62px;
                    }
                  }
      
                  &-img {
                    width: 104px;
                    height: 104px;
                    background: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 10px;
      
                    img {
                      width: 88px;
                      height: 88px;
                    }
                  }
      
                  &-btn {
                    line-height: 32px;
                    background: #FA2314;
                    color: #fff;
                    margin-top: 6px;
                    font-weight: 700;
                    width: 104px;
                  }
                }
              }
            }
    }
    }
    }
   
  }
   // -------------------------小屏幕适配-------------------
  @media screen and (min-width: 1264px) and (max-width: 1724px) {
    .download__layout {
    
        position: relative;
        color: #FFFFFF;
        padding-top: 100px;
    
        .hover {
          cursor: pointer;
        }
    
        .download-container {
          background: url('../../assets/imgs/home/download-bg.png') no-repeat;
          background-size: 100% 100%;
          box-sizing: border-box;
          padding: 50px 0;
          height: 546px;
    
          .download-box {
            width: 1000px;
            margin: auto;
            position: relative;
            z-index: 2;
    
            .download-tab {
              display: flex;
              font-size: 24px;
              font-weight: 700;
              margin-bottom: 40px;
    
              >div {
                margin-right: 62px;
                cursor: pointer;
                position: relative;
    
                span {
                  width: 40px;
                  height: 4px;
                  background: #FA2314;
                  position: absolute;
                  bottom: -12px;
                  left: 0;
                  right: 0;
                  margin: auto;
                }
              }
            }
    
            .download-title {
              margin-bottom: 28px;
    
              p {
                &:first-child {
                  font-size: 23px;
                  margin-bottom: 12px;
    
                }
    
                &:nth-child(3),
                &:nth-child(4) {
                  display: none;
                }
              }
            }
    
            .download-introduce {
              display: block;
              flex-wrap: wrap;
    
              >div {
                display: inline-block;
                width: 250px;
                margin-bottom: 18px;
    
                img {
                  position: relative;
                  top: 6px;
                  margin-right: 18px;
                }
              }
            }
    
            .downloads {
              display: none;
    
            }
    
            .download-introduces {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              text-align: center;
    
              >div {
                display: inline-block;
                width: 50%;
                margin-bottom: 18px;
    
                img {
                  position: relative;
                  top: 6px;
                  margin-right: 10px;
                  width: 24px;
                  height: 24px;
                }
    
                span {
                  font-size: 14px;
                }
              }
            }
    
            .download-introduce-two {
              width: 567px;
              line-height: 26px;
            }
    
          }
    
          .download-mobile-img {
            position: absolute;
            width: 522px;
            right: 0px;
            bottom: 0;
          }
    
          .download-computer-img {
            position: absolute;
            width: 618px;
            right: 0;
            bottom: 30px;
          }
    
          .download-code {
            display: flex;
            text-align: center;
            margin-top: 32px;
            position: relative;
            z-index: 2;
    
            &-cell {
              margin-right: 34px;
    
              &-title {
                font-weight: 700;
                margin-bottom: 20px;
                font-size: 18px;
              }
    
              &-box {
                display: flex;
                justify-content: center;
                margin-bottom: 25px;
    
                .code-item {
                  margin-right: 12px;
    
                  &:last-child {
                    margin-right: 0;
    
                    img {
                      width: 62px;
                      height: 62px;
                    }
                  }
    
                  &-img {
                    width: 104px;
                    height: 104px;
                    background: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 10px;
    
                    img {
                      width: 88px;
                      height: 88px;
                    }
                  }
    
                  &-btn {
                    line-height: 32px;
                    background: #FA2314;
                    color: #fff;
                    margin-top: 6px;
                    font-weight: 700;
                  }
                }
              }
            }
          }
    
          .download-tips {
            color: #93939F;
            font-size: 12px;
          }
    
          .download-mt5 {
            display: none;
          }
    
          .download-mt4 {
            display: none;
          }
        }
      }
  }
</style>
